import React from 'react'
import { Switch, Route } from 'react-router-dom'
import slug from 'constants/slug'
import OrganizationList from './organization-list'
import OrganizationCreate from './organization-create'
import OrganizationEdit from './organization-edit'
import OrganizationRule from './organization-rule'
import OrganizationPackage from './organization-package'

export default props => (
  <Switch>
    <Route
      exact
      path={slug.organization.list}
      render={matchProps => <OrganizationList {...matchProps} {...props} />}
    />
    <Route
      path={slug.organization.create}
      render={matchProps => <OrganizationCreate {...matchProps} {...props} />}
    />
    <Route path={slug.organization.edit} component={OrganizationEdit} />
    <Route path={slug.organization.rule} component={OrganizationRule} />
    <Route
      path={slug.organization.packageInfo}
      component={OrganizationPackage}
    />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/containers/organization/index.js